module.exports = __webpack_public_path__ + "static/img/2.644a6a4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/5/zh/2.png
// module id = qbmy
// module chunks = 0